import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { useParams } from "react-router";
import classNames from "classnames";
import { BrowserStorage, getSessionStorage } from "@jti/rest-api";
import { fetchContactEmail, fetchOrderPoints, fetchPaymentMethod, redirectToCartPage, resetOrderNumber, useDispatch, } from "@jti/store";
import { ConsentReminderDialog, Info, Loading, SobQuiz, Survey, useConfig, useTranslations } from "@jti/ui";
import { OrderSummary } from "../../components/OrderSummary";
import { SuccessfulPaymentMessage } from "../../components/SuccessfulPaymentMessage";
import { useAemModel } from "../../contexts";
import { useGtm } from "../../hooks/gtm/useGtm";
import { useConsentPopUp } from "../../hooks/useConsentPopUp";
import { useFreeTrial } from "../../hooks/useFreeTrial";
import { useOrder } from "../../hooks/useOrder";
import OrderView from "./components/Order";
import OrderLoyaltyConfirmation from "./components/OrderLoyaltyConfirmation";
import { OrderSummaryPageWarningMessage } from "./components/OrderSummaryPageWarningMessage";
import styles from "./OrderSummary.module.scss";
export const OrderSummaryPage = () => {
    const { AUTH_PAGE_URL, showDetailedSummaryOnThankYouPage, showQuizOnThankYouPage, showNewThankYouPage } = useConfig();
    const dispatch = useDispatch();
    const { dispatchGtmOrderSummaryPurchase, updateGtmPageName } = useGtm();
    const { orderId, paymentToken } = useParams();
    const { __ } = useTranslations();
    const { taxInfo: additionalTaxInfo, survey, sob, consentReminderPopup } = useAemModel();
    const earnedPoints = getSessionStorage().get("loyaltyCartPoints", 0);
    const { isFreeTrial } = useFreeTrial();
    const { isConsentPopUpVisible, closeConsentsPopUp } = useConsentPopUp();
    const { paymentMethod, points, summaryPrices, order, fetchOrder, contactEmail, orderFetchStatus, hasLoyalty, pending_points, } = useOrder();
    useEffect(() => {
        if (orderId) {
            fetchOrder(orderId);
            dispatch(fetchContactEmail());
            if (paymentToken) {
                dispatch(fetchPaymentMethod(paymentToken));
            }
        }
    }, [orderId, paymentToken]);
    useEffect(() => {
        if (orderId && hasLoyalty) {
            dispatch(fetchOrderPoints(orderId));
        }
    }, [orderId, hasLoyalty, dispatch]);
    useEffect(() => {
        if (!new BrowserStorage().get("user", null)) {
            window.location.pathname = AUTH_PAGE_URL;
        }
        // GTM Page Info Update
        const templateType = isFreeTrial ? "free-trial-order-confirmation-page" : "order-confirmation";
        updateGtmPageName(templateType);
    }, [isFreeTrial, AUTH_PAGE_URL]);
    useEffect(() => {
        if (orderFetchStatus === "success" && order) {
            dispatchGtmOrderSummaryPurchase(order);
        }
        if (orderFetchStatus === "error") {
            redirectToCartPage();
        }
        return () => {
            dispatch(resetOrderNumber());
        };
    }, [orderFetchStatus]);
    return (_jsxs(_Fragment, { children: [_jsx(ConsentReminderDialog, { title: consentReminderPopup?.mainQuestion || "", subtitle: consentReminderPopup?.subtitle || "", description: consentReminderPopup?.description || "", primaryButtonText: consentReminderPopup?.yesButtonText || "", secondaryButtonText: consentReminderPopup?.noButtonText || "", mainImage: consentReminderPopup?.mainImage || "", imageAltText: consentReminderPopup?.imageAltText || "", onPrimaryButtonClick: () => {
                    consentReminderPopup?.yesRedirectUrl && window.open(consentReminderPopup.yesRedirectUrl, "_blank");
                    closeConsentsPopUp();
                }, onSecondaryButtonClick: () => {
                    closeConsentsPopUp();
                }, isOpened: isConsentPopUpVisible }), showNewThankYouPage ? (_jsx(_Fragment, { children: _jsxs("div", { className: classNames(styles.container, {
                        [styles.containerWithQuiz]: showQuizOnThankYouPage,
                    }), children: [_jsx(SuccessfulPaymentMessage, {}), showQuizOnThankYouPage && survey && _jsx(Survey, { scriptUrl: survey.scriptUrl }), showQuizOnThankYouPage && !survey && sob?.data && _jsx(SobQuiz, { data: sob.data }), orderFetchStatus === "success" && (_jsx(OrderSummary, { title: __("cart.order.summary.noItemsTitle"), pointsToEarn: earnedPoints, additionalTaxInfo: additionalTaxInfo, showDetailedSummary: showDetailedSummaryOnThankYouPage }))] }) })) : (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.title, children: __("cart.title.order") }), _jsx(Info, { variant: "checkmark", className: styles.info, message: __("cart.order.succesfully_placed") }), _jsxs("div", { "data-testid": "orderViewContainer", className: styles.oldContainer, children: [_jsx("div", { className: styles.emailPhrase, children: orderFetchStatus === "success" && (_jsxs("p", { children: [__("cart.order.confirmation_sent_email"), " ", _jsx("strong", { children: contactEmail })] })) }), orderFetchStatus === "pending" && _jsx(Loading, {}), orderFetchStatus === "success" && (_jsxs(_Fragment, { children: [_jsx(OrderLoyaltyConfirmation, { isActive: hasLoyalty && !isFreeTrial, totalPoints: points, pendingPoints: pending_points }), _jsx(OrderView, { prices: summaryPrices, order: order, paymentMethod: paymentMethod, isFreeTrial: isFreeTrial })] })), _jsx(OrderSummaryPageWarningMessage, { className: styles.trialMessage, isFreeTrial: isFreeTrial })] })] }))] }));
};
//# sourceMappingURL=OrderSummaryPage.js.map